import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LocalStorageService } from 'ngx-webstorage';
import { User } from 'src/app/model/user';
import { NotificationService } from 'src/app/service/notification.service';
import { CreateClientsRequest } from './../../../model/management-config/clientManagement';
import { ClientManagementService } from './../../../service/clientManagement.service';
import {TestsService} from '../../../service/tests.service';
import {Tests} from '../../../model/tests/tests';
import {TestsComponent} from '../../tests/tests.component';

@Component({
  selector: 'app-add-client',
  templateUrl: './add-client.component.html',
  styleUrls: ['./add-client.component.scss']
})
export class AddClientComponent implements OnInit {

  @ViewChild(TestsComponent) testsComponent: TestsComponent;

  _clientForm: FormGroup;
  client: CreateClientsRequest = new CreateClientsRequest();
  updatedBy: string;
  profile: User = new User;
  email: string;
  tests: Tests;

  constructor(
    private clientService: ClientManagementService,
    private _formBuilder: FormBuilder,
    private _localStorage: LocalStorageService,
    private _notificationService: NotificationService,
    private testsService: TestsService,
    public dialogRef: MatDialogRef<AddClientComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CreateClientsRequest
    ) { }

  ngOnInit() {
    this._clientForm = this._formBuilder.group({
      clientName: new FormControl(this.client.clientName),
      clientDesc: new FormControl({ value: this.client.clientDesc, disabled: false }),
      createdBy: new FormControl({ value: this.client.createdBy, disabled: false }),
    });
    this.testsService.getTests().subscribe(
      result => this.tests = result.tests,
      error => console.log(error)
    );
  }

  onSubmit() {
    this.client = this._clientForm.value;
    this.client.tests = this.testsComponent.tests.value;
    this.client.createdBy = this._localStorage.retrieve('profile').displayName;
    this.clientService.addClientRequests(this.client)
      .subscribe(data => {
        console.log(data);
        this.dialogRef.close(this._clientForm.value);
        if (data.successFlag){
          this._notificationService.success('Client added successfully');
        }else{
          if (data.errorCode == 'EXISTING_CLIENT_EXCEPTION'){
          this._notificationService.error(data.errorMsg);
          }else{
            this._notificationService.error('Creating client Failed');
          }
        }
      }, error => console.log(error));
  }
}
